$(document).ready(function () {
    if ($('.slideshow')) {
        $('.slideshow').slick({
            dots: true,
            speed: 800,
            slidesToShow: 1,
            slidesToScroll: 1,
            fade: true,
            variableWidth: false,
            centerMode: true,
            centerPadding: '0',
            mobileFirst: true,
            arrows: false,
            nextArrow: '<button class="slick-next slick-arrow" aria-label="Nästa">Nästa</button>',
            prevArrow: '<button class="slick-prev slick-arrow" aria-label="Förra">Förra</button>',
            infinite: true,
            customPaging: function (slider, i) {
                var stornyhetspuff = $('.slick-slide[data-slick-index|=' + i + ']').find('.block-inner').first();
                var titel = stornyhetspuff.attr('data-titel');
                var namn = stornyhetspuff.attr('data-namn');
                var ikon = stornyhetspuff.attr('data-ikon');

                return '<div class="tumnagel-cirkel" style="background-image: url(' + ikon + ')"></div ><a href="#" class="namn">' + namn + '</a><div class="titel">' + titel + '</div>';
            },
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        arrows: true
                    }
                }
            ]
        });
    }
});
